var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:`c-toggle-button ${_vm.active ? 'c-toggle-button--active' : ''}`,on:{"click":_vm.onChangeStatus}},[_c('span',{staticClass:"c-toggle-button__circle"})])
}
var staticRenderFns = []

export { render, staticRenderFns }